"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { includeIf } from "../../../utils/includeIf";
export const mapTextInputProps = (render) => {
  return (fieldProps) => {
    var _e;
    const _a = fieldProps, {
      input: _b
    } = _a, _c = _b, { type, onChange } = _c, inputElementProps = __objRest(_c, ["type", "onChange"]), _d = _a, {
      meta: { error, submitError, data = {} },
      onChange: textInputOnChange
    } = _d, rest = __objRest(_d, [
      "input",
      "meta",
      "onChange"
    ]);
    const mappedError = (_e = error != null ? error : submitError) != null ? _e : void 0;
    const mappedProps = __spreadProps(__spreadValues(__spreadValues(__spreadValues({
      error: data.showValidationErrors ? mappedError : void 0
    }, inputElementProps), rest), includeIf(!!type, {
      type
    })), {
      onChange: (ev) => {
        if (textInputOnChange) {
          textInputOnChange(ev);
        }
        if (onChange) {
          onChange(ev);
        }
      }
    });
    return render(mappedProps);
  };
};
export const mapSegmentedControlProps = (render) => {
  return (fieldProps) => {
    var _e;
    const _a = fieldProps, {
      input: _b
    } = _a, _c = _b, { value, onChange } = _c, inputElementProps = __objRest(_c, ["value", "onChange"]), _d = _a, {
      meta: { error, submitError, data = {} },
      onChange: segmentedOnChange
    } = _d, rest = __objRest(_d, [
      "input",
      "meta",
      "onChange"
    ]);
    const mappedError = (_e = error != null ? error : submitError) != null ? _e : void 0;
    const mappedProps = __spreadProps(__spreadValues(__spreadValues({
      error: data.showValidationErrors ? mappedError : void 0
    }, inputElementProps), rest), {
      value,
      onChange: (ev) => {
        if (segmentedOnChange) {
          segmentedOnChange(ev);
        }
        if (onChange) {
          onChange(ev);
        }
      }
    });
    return render(mappedProps);
  };
};
export const mapSelectProps = (render) => {
  return (fieldProps) => {
    var _e;
    const _a = fieldProps, {
      input: _b
    } = _a, _c = _b, { type, onBlur, onFocus } = _c, inputElementProps = __objRest(_c, ["type", "onBlur", "onFocus"]), _d = _a, {
      meta: { error, submitError, data = {} }
    } = _d, rest = __objRest(_d, [
      "input",
      "meta"
    ]);
    const mappedError = (_e = error != null ? error : submitError) != null ? _e : void 0;
    const mappedProps = __spreadValues(__spreadValues({
      error: data.showValidationErrors ? mappedError : void 0
    }, inputElementProps), rest);
    return render(mappedProps);
  };
};
export const mapCheckboxProps = (fieldProps) => {
  var _e;
  const _a = fieldProps, {
    input: _b
  } = _a, _c = _b, { type, onBlur, onFocus } = _c, inputElementProps = __objRest(_c, ["type", "onBlur", "onFocus"]), _d = _a, {
    meta: { error, submitError, data = {} }
  } = _d, rest = __objRest(_d, [
    "input",
    "meta"
  ]);
  const mappedError = (_e = error != null ? error : submitError) != null ? _e : void 0;
  return data.showValidationErrors ? mappedError : void 0;
};
